module.exports = __webpack_public_path__ + "static/img/ic_qb_sale_regist@2x.941d692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_qb_sale_regist@2x.png
// module id = 7yZq
// module chunks = 1